import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useNewsbreakBusinessManagerStore = defineStore({
  id: 'newsbreakBusinessManagerStore',
  state: () => ({
    newsbreakBusinessManagers: [],
    newsbreakBusinessManagersLoading: false,
    error: null,
  }),
  actions: {
    async getNewsbreakBusinessManagers(filters = {}, withRelation = undefined) {
      this.error = null
      this.newsbreakBusinessManagersLoading = true

      try {
        const {data} = await axios.get('newsbreak/business-managers', {
          params: {...filters, with: withRelation},
        })

        this.newsbreakBusinessManagers = data

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.newsbreakBusinessManagersLoading = false
      }
    },
  },
})
